import axios from '@/libs/axios'

export default {
  loadTable(queryFilter = {}) {
    let queryUrl = ''
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/evento/evento_campos${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/evento/evento_campos', data)
  },
  edit(data) {
    return axios.put(`/evento/evento_campos/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/evento/evento_campos/${id}`)
  },
}
